// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9698) return "static/chunks/9698-a841daad55c617f6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"332":"9dce580c638d6603","3179":"888d23300ac82e6b","5560":"1b5a46c09c91fce0","7573":"3b441344de9eea9d"}[chunkId] + ".js";
};